import {
  ScmAuth,
  scmAuthApiRef,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  createApiFactory,
  microsoftAuthApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmAuthApiRef,
    deps: { microsoftAuthApi: microsoftAuthApiRef },
    factory: ({ microsoftAuthApi }) =>
      ScmAuth.merge(
        ScmAuth.forAzure(microsoftAuthApi),
      ),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
];
